(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('form'), el = form.elements;
    const error = root.querySelector('[data-error]'), body = root.querySelector('tbody');
    let state;
    function draw() {
      if (!state) return;
      const canvas = root.querySelector('canvas'), ctx = canvas.getContext('2d');
      const w = canvas.clientWidth, h = 330, scale = Math.min(window.devicePixelRatio || 1, 2);
      if (!w || !ctx) return;
      canvas.width = w * scale; canvas.height = h * scale; ctx.scale(scale, scale);
      const { ratios, rear, tire, redline } = state;
      const ymax = Math.ceil(redline * 1.2 / 1000) * 1000, xmax = 120;
      const left = 48, top = 32, width = w - 64, height = h - 72;
      const x = v => left + v / xmax * width, y = v => top + height - v / ymax * height;
      ctx.font = '11px Arial'; ctx.lineWidth = 1;
      for (let i = 0; i <= 4; i++) {
        const rpm = ymax * i / 4;
        ctx.strokeStyle = '#383a33'; ctx.beginPath(); ctx.moveTo(left, y(rpm)); ctx.lineTo(w - 16, y(rpm)); ctx.stroke();
        ctx.fillStyle = '#b8b6ad'; ctx.textAlign = 'right'; ctx.fillText(Math.round(rpm), left - 7, y(rpm) + 4);
      }
      ctx.textAlign = 'center';
      for (let mph = 0; mph <= xmax; mph += 30) ctx.fillText(mph, x(mph), h - 20);
      const colors = ['#b6a078','#d8d1bf','#8fa99b','#a4a5bd','#c39a84','#8eacb5','#b4ae88','#ac94a3','#d4bcad','#a3b4ca'];
      ratios.forEach((g, i) => {
        const end = Math.min(xmax, ymax * tire / (g * rear * 336));
        ctx.strokeStyle = colors[i]; ctx.beginPath(); ctx.moveTo(x(0), y(0)); ctx.lineTo(x(end), y(end * g * rear * 336 / tire)); ctx.stroke();
        ctx.fillStyle = colors[i]; ctx.textAlign = 'left'; ctx.fillText('G' + (i + 1), x(end) - 18, Math.max(14, y(end * g * rear * 336 / tire) - 7));
      });
      ctx.strokeStyle = '#cc9884'; ctx.setLineDash([5, 5]); ctx.beginPath(); ctx.moveTo(left, y(redline)); ctx.lineTo(w - 16, y(redline)); ctx.stroke(); ctx.setLineDash([]);
    }
    function update(event) {
      if (event) event.preventDefault();
      root.querySelector('[data-custom]').hidden = el.preset.value !== 'custom';
      el.ratios.disabled = el.preset.value !== 'custom';
      const metricMode = el.tireMode.value === 'metric';
      root.querySelector('[data-metric]').hidden = !metricMode; el.tire.disabled = metricMode; el.metric.disabled = !metricMode;
      const metricMatch = el.metric.value.trim().match(/^P?(\d{3})\/(\d{2,3})R(\d{2})$/i);
      let tire = Number(el.tire.value);
      if (metricMode) tire = metricMatch ? Number(metricMatch[3]) + 2 * Number(metricMatch[1]) * Number(metricMatch[2]) / 100 / 25.4 : NaN;
      const metricInvalid = metricMode && (!Number.isFinite(tire) || tire < 1 || tire > 100);
      el.metric.setAttribute('aria-invalid', String(metricInvalid));
      const ratios = (el.preset.value === 'custom' ? el.ratios.value : el.preset.value).split(',').map(v => Number(v.trim()));
      let invalid = metricInvalid || !ratios.length || ratios.length > 10 || ratios.some(v => !Number.isFinite(v) || v <= 0 || v > 20);
      el.ratios.setAttribute('aria-invalid', String(invalid));
      ['rear', 'tire', 'rpm', 'mph', 'redline'].forEach(name => {
        const input = el[name]; const bad = !input.validity.valid || !Number.isFinite(Number(input.value));
        input.setAttribute('aria-invalid', String(bad)); invalid = invalid || bad;
      });
      error.hidden = !invalid;
      if (invalid) {
        error.textContent = 'Enter positive values within the input limits and 1–10 valid gear ratios. Use a metric size such as 225/70R15.';
        body.replaceChildren(); root.querySelector('[data-summary]').textContent = 'Check the highlighted inputs to calculate results.';
        state = null; const c = root.querySelector('canvas'); c.getContext('2d').clearRect(0, 0, c.width, c.height); return;
      }
      const rear = +el.rear.value, rpm = +el.rpm.value, mph = +el.mph.value, redline = +el.redline.value;
      state = {ratios, rear, tire, redline}; body.replaceChildren();
      ratios.forEach((ratio, i) => {
        const overall = ratio * rear, row = document.createElement('tr');
        [i + 1, ratio.toFixed(2), overall.toFixed(3), (rpm * tire / (overall * 336)).toFixed(1), Math.round(mph * overall * 336 / tire).toLocaleString()].forEach(value => {const td = document.createElement('td'); td.textContent = value; row.append(td);});
        body.append(row);
      });
      root.querySelector('[data-rpm]').textContent = rpm.toLocaleString(); root.querySelector('[data-mph]').textContent = mph;
      const topRpm = Math.round(mph * ratios[ratios.length - 1] * rear * 336 / tire);
      root.querySelector('[data-summary]').textContent = `${topRpm.toLocaleString()} RPM at ${mph} MPH in top gear.${topRpm > redline ? ' This exceeds your selected redline.' : ''}`;
      draw();
    }
    form.addEventListener('submit', update); form.addEventListener('input', update); form.addEventListener('change', update);
    if ('ResizeObserver' in window) new ResizeObserver(draw).observe(root.querySelector('canvas'));
    update();
  }
  function boot(scope) { scope.querySelectorAll('[data-np-gear]').forEach(init); }
  boot(document); document.addEventListener('shopify:section:load', e => boot(e.target));
})();
